import { Switch } from 'antd';
import type { ReactNode } from 'react';
import { useState } from 'react';

import { RemoveAlwaysIncludedModal } from '../RemoveAlwaysIncludedModal/RemoveAlwaysIncludedModal';

type OvernightRuleSwitchFieldProps = {
  value?: boolean;
  onChange?: (value: boolean) => void;
  disabled?: boolean;
  children?: ReactNode;
};

export const OvernightRuleSwitchField = ({
  value = false,
  onChange,
  disabled,
  children,
}: OvernightRuleSwitchFieldProps) => {
  const [showRemoveModal, setShowRemoveModal] = useState(false);

  const handleCancelRemove = () => {
    setShowRemoveModal(false);
  };

  return (
    <div>
      <Switch
        checked={value}
        disabled={disabled}
        onChange={(checked) => {
          if (value && !checked) {
            setShowRemoveModal(true);
          } else {
            onChange?.(checked);
          }
        }}
      />
      {children}
      <RemoveAlwaysIncludedModal
        open={showRemoveModal}
        onCancel={handleCancelRemove}
        onChange={onChange}
      />
    </div>
  );
};
